import React, { FC, useState } from 'react'

type Props = {
    fieldPropId: string
    fieldProps: any
    props: any
    touched: any
    errors: any
    displayText: string
    verticalLabel?: boolean
}

export const AncientInputTextId: React.FC<Props> = ({ displayText, props, fieldProps, fieldPropId, touched, errors, verticalLabel }) => {


    const formatText = async (e: any) => {
        let newValue;
        newValue = e.target.value.toLowerCase()
        newValue = newValue.replace(/ /g, "_")
        newValue = newValue.replace(/[^a-zA-Z0-9\_]+/g, "")

        //setTimeout(() => props.setFieldTouched(fieldPropId, newValue));

        await props.setFieldValue(fieldPropId, newValue)
        props.setFieldTouched(fieldPropId, true)
    }

    return (
        <>
            {verticalLabel == true ?
                <div className="mb-5">
                    <label className="form-label">{displayText}</label>
                    <input
                        type='text'
                        className='form-control form-control-lg mb-3 mb-lg-0'
                        onChange={(e) => { formatText(e); }}
                        value={fieldProps.value}
                        placeholder={displayText}
                    />
                    {touched && errors && (
                        <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>{errors}</div>
                        </div>
                    )}
                </div>
                :
                <div className='row mb-6'>
                    <label className='col-lg-4 col-form-label required fw-bold fs-6'>{displayText}</label>

                    <div className='col-lg-8'>
                        <div className='row'>
                            <div className='col-lg-12 fv-row'>
                                <input
                                    type='text'
                                    className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                                    onChange={(e) => { formatText(e); }}
                                    placeholder={displayText}
                                    {...fieldProps}
                                />
                                {touched && errors && (
                                    <div className='fv-plugins-message-container'>
                                        <div className='fv-help-block'>{errors}</div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    )
}
